module.exports = __webpack_public_path__ + "img/1546457120.3f3b6e2a.jpg";